import { render, staticRenderFns } from "./enroll-family-member-modal.vue?vue&type=template&id=2fc4b5bb&scoped=true&"
import script from "./enroll-family-member-modal.ts?vue&type=script&lang=ts&"
export * from "./enroll-family-member-modal.ts?vue&type=script&lang=ts&"
import style0 from "./enroll-family-member-modal.scss?vue&type=style&index=0&id=2fc4b5bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc4b5bb",
  null
  
)

export default component.exports